import React from "react";

interface IAppContext {
  searchQuery: string;
}

export const AppContext = React.createContext<IAppContext>({
  searchQuery: ""
});
